<template>
	<div class="new-message">
		<form @submit.prevent="addMessage">
			<label for="new-message">New Message (enter to add):</label>
			<input type="text" ref="input" name="new-message" v-model="newMessage"></input>
			<p class="red-text" v-if="feedback">{{ feedback }}</p>
		</form>
	</div>
</template>

<script>
import db from '@/firebase/init'

export default {
	name: 'NewMessage',
	props: ['name'],
	data() {
		return {
			newMessage: null,
			feedback: null,
		}
	},
	methods: {
		addMessage() {
			if (this.newMessage) {
				this.feedback = null
				console.log(this.name, this.newMessage, Date.now())
				db.collection('message').add({
					content: this.newMessage,
					name: this.name,
					timestamp: Date.now()
				}).then(()=>{
					console.log('stored!')
				}).catch(()=>{
					console.error('fail to store in firestore')
				})
				this.newMessage = ''
			}
			else {
				this.feedback = 'You must enter a message.'
			}
		}
	},
	mounted() {
		this.$nextTick( () => { this.$refs.input.focus() } )
	}
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/NewMessage.vue